'use client'

import { useINAppRouter } from '@routes/utils/useINAppRouter'

import { ReactElement } from 'react'
import RegistrationScreen from '@app/registration/_components/basic/RegistrationScreen'

function RegistrationContent(): ReactElement {
    const router = useINAppRouter()
    const step = router.searchParams?.get('step') === 'second' ? 'second' : 'first'

    return <RegistrationScreen step={step} />
}

export default RegistrationContent
